<template>
  <ProSpaceRightPanel
    v-show="isAdjustmentTab"
    class="adjustment-form-panel"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
  >
    <template v-slot:center>
      <ProSpaceTabs v-model="modelTab" :tabs="tabs">
        <template v-slot:tab-1>
          <ProSpaceTimeLineCondition
            :dateFormat="userinfo.dateFormat"
            :timeFormat="userinfo.timeFormat"
            :dateTimeFormatter="getFormatDateTime"
            :elems="adjustmentComments"
            :commentTile="$t('adjustmentComment')"
            :title="$t('adjustmentComments')"
            :showMarker="false"
            @add="showAdjustmentCommentModal"
          >
            <template v-if="!adjustmentComments.length" v-slot:empty>
              <ProSpaceEmptyGrid
                :title="$t('adjustmentEmptyCommentsTitleTxt')"
                :text="$t('adjustmentEmptyCommentsTextTxt')"
                icon="empty-grid"
              />
            </template>
          </ProSpaceTimeLineCondition>
        </template>
        <template #tab-2>
          <ProSpacePanelBlock :header="headerHistory">
          </ProSpacePanelBlock>
          <ProSpaceVLayout :gap="10" is-inline-h v-if="adjustment">

            <ProSpaceVLayout :gap="5" class="padding-10 ui-shadow" v-if="adjustment.createdAt">
              <ProSpaceHLayout justify-content="space-between">
                <span class="text-icon-gray text-size-11">{{ getFormatDateTime(adjustment.createdAt) }}</span>
                <ProSpaceTag :text="$t(adjustment.creatorRole || '')" type="gray-light" bordered />
              </ProSpaceHLayout>
              <ProSpaceHLayout class="padding-top-5">
                <span class="text-size-12 text-bold text-color-main">{{ adjustment.creatorDisplayName }}</span>
              </ProSpaceHLayout>
              <ProSpaceHLayout>
                <span class="text-size-12 text-color-accent">{{ $t('created') }}</span>
              </ProSpaceHLayout>
            </ProSpaceVLayout>

            <ProSpaceVLayout :gap="5" class="padding-10 ui-shadow" v-if="adjustment.acceptedAt">
              <ProSpaceHLayout justify-content="space-between">
                <span class="text-icon-gray text-size-11">{{ getFormatDateTime(adjustment.acceptedAt) }}</span>
                <ProSpaceTag :text="$t(adjustment.acceptorRole || '')" type="gray-light" bordered />
              </ProSpaceHLayout>
              <ProSpaceHLayout class="padding-top-5">
                <span class="text-size-12 text-bold text-color-main">{{ adjustment.acceptorDisplayName }}</span>
              </ProSpaceHLayout>
              <ProSpaceHLayout>
                <span class="text-size-12 text-color-accent">{{ $t('agreed') }}</span>
              </ProSpaceHLayout>
            </ProSpaceVLayout>

            <ProSpaceVLayout :gap="5" class="padding-10 ui-shadow" v-if="adjustment.approvedAt">
              <ProSpaceHLayout justify-content="space-between">
                <span class="text-icon-gray text-size-11">{{ getFormatDateTime(adjustment.approvedAt) }}</span>
                <ProSpaceTag :text="$t(adjustment.approverRole || '')" type="gray-light" bordered />
              </ProSpaceHLayout>
              <ProSpaceHLayout class="padding-top-5">
                <span class="text-size-12 text-bold text-color-main">{{ adjustment.approverDisplayName }}</span>
              </ProSpaceHLayout>
              <ProSpaceHLayout>
                <span class="text-size-12 text-color-accent">{{ $t('approved') }}</span>
              </ProSpaceHLayout>
            </ProSpaceVLayout>

          </ProSpaceVLayout>
        </template>
      </ProSpaceTabs>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceTimeLineCondition,
  ProSpaceInputText,
  ProSpaceModal,
  ProSpaceVLayout,
  ProSpaceHLayout,
  ProSpaceEmptyGrid,
  ProSpaceTag
} from "@prospace/prospace-components-library";
import { AdjustmentService } from "../../../services/AdjustmentService";
import { AdjustmentCommentService } from "../../../services/AdjustmentCommentService";
import { mapGetters } from "vuex";
export default {
  name: "AdjustmentPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceTimeLineCondition,
    ProSpaceInputText,
    ProSpaceModal,
    ProSpaceVLayout,
    ProSpaceHLayout,
    ProSpaceEmptyGrid,
    ProSpaceTag,
  },
  props: {
    adjustment: {
      type: Object,
      required: true,
    },
    periodId: {
      type: Number,
      required: true,
    },
    isProceeded: {
      type: Boolean,
      default: false
    },
    isAdjustmentTab: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      adjustmentComments: [],

      adjustmentService: new AdjustmentService(),
      adjustmentCommentService: new AdjustmentCommentService(),

      loading: false,
      hasError: false,

      modelTab: {
        name: this.$t("adjustmentComments"),
        isActive: true,
        systemName: "adjustmentComments",
      },
    };
  },
  watch: {
    // isAdjustmentTab(val) {
    //   if(val)
    //     this.getComments();
    // },
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
      currentPeriod: "marsPeriodStoreArchived/getMarsPeriod",
    }),
    headerAdjustments() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    openKpi() {
      return {
        title: this.$t("openKpi"),
      };
    },
    businessKpi() {
      return {
        title: this.$t("businessKpi"),
      };
    },
    budgetHeader() {
      return {
        title: this.$t("budget"),
      };
    },
    tabs() {
      return [
        {
          name: this.$t("adjustmentComments"),
          systemName: "adjustmentComments",
          isActive: this.modelTab.systemName === "adjustmentComments",
          isHidden: !this.isAdjustmentTab,
        },
        {
          name: this.$t("history") ,
          systemName: "history",
          isActive: this.modelTab.systemName === "history"
        },
      ];
    },
    header() {
      let header = {};
      if (this.adjustment && this.isAdjustmentTab) {
        header = {
          title: this.adjustment.networkValue,
          id: this.adjustment.code,
          status: this.getStatus(this.adjustment.status),
          showCounter: false,
        };
      }
      return header;
    },
    headerHistory() {
      return {
        title: this.$t('history'),
        isExpand: false
      }
    },
  },
  mounted() {
    this.getComments();
  },
  methods: {
    getStatus(status) {
      if (!status) return;

      let type = "default"
      switch (status) {
        case "onacceptance":
          type = "light-blue"
          break;
        case "onapproval":
          type = "blue"
          break;
        case "completed":
          type = "teal"
          break;
        case "deleted":
          type = "draft"
          break;
      }

      return {
        type: type,
        text: status !== 'deleted' ? this.$t(status) : this.$t('adjustmentDeleted'),
      };
    },
    getComments() {
      this.loading = true;
      this.adjustmentCommentService
        .getByAdjustmentId(this.adjustment.id, this.periodId)
        .then((res) => {
          this.adjustmentComments = res.data.records.map((x) => {
            const role = this.$t((x.role)) || '';
            return {
              securityUserType: role,
              confirmDate: x.createdAt,
              securityUserFirstName: x.fio.split(" ")[0],
              securityUserLastName: x.fio.split(" ")[1],
              comment: x.comment,
            };
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.adjustment-form-panel {
  border-top: none;
  border-left: none;
  &__list {
    :deep(.prospace-panel-block__body) {
      padding: 0;
    }
  }
  :deep(.prospace-panel-block-item__content_text) {
    font-size: 12px;
  }
  :deep(.prospace-timeline-condition .time-line-header .prospace-action-text) {
    font-size: 12px;
  }
  :deep(.prospace-timeline-condition .time-line-element .prospace-tag__text) {
    font-weight: 400;
  }
  :deep(.prospace-timeline-condition .time-line-element .time-line-element__comment-title) {
    color: var(--prospace-tag-draft);
  }
  :deep(.prospace-panel-header__subline .prospace-tag) {
    font-size: 11px;
  }
  :deep(.prospace-panel-header__subline .prospace-tag--gray-light) {
    font-weight: 400;
  }
}
.prospace-timeline-condition {
  width: 100%;
}
</style>
